<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-header-menu-account" v-bind:class="{'selected': isSelected}">
      <el-dropdown 
        class="wy-header-manu-dropdown" 
        ref="accountWidget" 
        placement="top" 
        trigger="click"
        :hide-on-click="true" 
        @visible-change="handleChangeVisible">
        <span class="el-dropdown-title wy-disable-select">
          <div class="el-dropdown-subtitle accountHeader">
            <i class="nav-el-icon el-icon-account"></i>
            <span class="header-title">Account</span>
          </div>
        </span>
        <el-dropdown-menu class="wy-header-menu-panel wy-header-menu-account-panel" slot="dropdown">
          <!-- <transition name="bounce"> -->
            <div class="menu-panel" v-if="isShow">
              <div class="panel-column platform-panel" style="width: 100%;">
                <div class="title-header" :title="user.firstName + ' ' + user.lastName" style="margin: 0px 0px;">{{user.firstName}}&nbsp;{{user.lastName}}</div>
                <div class="panel-content">
                  <el-dropdown-item :label="item.name" :disabled="item.isDisabled" v-for="(item, index) in accountItems" :command="index" :key="item.key" @click.native="handleClickItem(item)">
                    {{item.name}}
                  </el-dropdown-item>
                </div>
                <div class="panel-sign-out">
                  <el-dropdown-item @click.native="handleLogout">
                    Sign out
                  </el-dropdown-item>
                </div>
              </div>
            </div>
          <!-- </transition> -->
        </el-dropdown-menu>
      </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'wy-header-menu-brand',
  data() {
    return {
      user: null,
      selectedCommand: 0,
      isShow: false,
      isSelected: false,
      accountItems: []
    }
  },
  computed: {   
    ...mapGetters(['authUser', 'config', 'isAdminUser', 'isSysAdminUser']),
  },

  methods: {
    ...mapActions(['logout']),

    handleChangeVisible(isOpen) {
      if(isOpen){
        if(this.$root.preMsgObj) {
          this.$root.preMsgObj.close();
        }
        this.$refs.accountWidget.show();
        this.$refs.accountWidget.popperElm.style.transitionDelay = "0s";
        this.isShow = true;
        this.isSelected = true;
      }
      else {
        this.$refs.accountWidget.hide();
        this.$refs.accountWidget.popperElm.style.transitionDelay = "0.01s";
        // this.isShow = true;
        this.isSelected = false;
      }
    },

    handleClickItem(item) {
      if(item.eventTarget) {
        this.$root.$emit(`fire-app-modal-events`, item.eventTarget);
      }
    },

    async handleLogout() {      
      this.$router.checkUnsaveChanges(async () => {
        this.$store.dispatch('logout', 'manual');
        this.$router.replace({name: 'logout'});
      });
    },
  },

  created() {
    this.user = this.authUser.user;
    this.accountItems = []
    this.accountItems.push(
      {
        "key": "profile",
        "name": "Profile",
        "eventTarget": "/user/wy-account-profile.vue",
        "isDisabled": false
      }
    )
    if(this.isAdminUser) {
      this.accountItems.push(
        {
          "key": "account",
          "name": "Account",
          "eventTarget": "/management/wy-management.vue",
          "isDisabled": false
        }
      )
    }
    if(this.isSysAdminUser) {
      this.accountItems.push(
        {
          "key": "configurations",
          "name": "Configurations",
          "eventTarget": "/configurations/wy-configurations.vue",
          "isDisabled": false
        }
      )
    }
    // this.accountItems.push(
    //   {
    //     "key": "privacy",
    //     "name": "Privacy",
    //     "isDisabled": false
    //   }
    // )
    // this.accountItems.push(
    //   {
    //     "key": "help",
    //     "name": "Help",
    //     "isDisabled": false
    //   }
    // )
  }
}
</script>

<style lang="scss">
.wy-app-modal-content {
    width: 66% !important;
}
.wy-app-modal-header-close {
  position: relative !important;
  bottom: 7px !important;
}
.wy-app-modal .wy-app-modal-content {
    width: 1350px!important;
    overflow: auto;
}
.wy-header-menu-account {
  // margin-left: 2px;
  height: 100px;
  width: 210px;
  // .wy-header-manu-dropdown {
  //   margin: 10px 0px 0px 0px !important;
  //   .el-dropdown-title {
  //     padding-left: 0px !important;
  //     .el-dropdown-subtitle {
  //       padding-right: 2px !important;
  //       padding-left: 2px;
  //     }
  //   }
  // }
  .wy-header-manu-dropdown{
    margin: 0px 0px 0px 0px !important;
    padding: 19px 0px 0 0px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    height: 38px !important;
    top: 9px !important;
  }
  .wy-header-manu-dropdown.el-dropdown:hover {
    // background-color: rgba(229, 234, 242, 0.09);
  }
}

// .wy-header-menu-brand {
//   .wy-header-menu-date-filter-picker {
//     visibility: hidden !important;
//     width: 1px !important;
//     height: 10px !important;
//   }
// }
.wy-header-menu-account.selected {
  height: 100px;
  background: #020E14 0% 0% no-repeat padding-box !important;
}

.wy-header-menu-panel.wy-header-menu-account-panel {
      width: 306px;
      padding: 0px 0 0px 0px;
      top: 63px !important;
      left: calc(100% - 306px) !important;
      // border-top: 1px white solid !important;
      .panel-column {
        display: inline-grid;
        width: fit-content;
        padding: 0px 0px 2px 0px;
      }
  
      .el-dropdown-menu__item {
        padding: 10px 40px !important;
        line-height: 29px;
        font-size: 14px;
        font-weight: 500;
        color: #F4F6F8;
        background-color: #020E14;
      }
      .panel-content {
        padding-top: 0px;
        border-top: 1px solid #CCC;
      }
      .title-header {
        font-weight: 600;
        font-size: 14px;
        color: #F4F6F8;
        // padding: 7px 15px 2px 15px;
        padding: 15px 25px 20px 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .panel-sign-out {
        padding-top: 0px;
        border-top: 1px solid #CCC;
        li {
          color: #F4F6F8;
          font-weight: 600;
        }
        .el-dropdown-menu__item:not(.is-disabled):hover {
          color: #F4F6F8;
          background-color: rgba(229, 234, 242, 0.09);
        }
      }
    }
    
    @media (max-width: 1540px){
      .wy-header-menu-panel.wy-header-menu-account-panel {
        left: 1234px !important;
      }
    }

</style>